export default {
  heading: "Register to my existing EdCity account",
  intro: "Thank you for logging into EdCity website.Your account has not been registered with any EdCity account.",
  completed: "Account registered successfully. You can login EdCity website with your account.",
  submit: "Submit",
  iamsmart: {
    intro: "This is your first time logging into EdCity website with “iAM Smart”. Please log in with your EdCity account to complete the link up process.",
  },
 form: {
  label: {
    loginId: "Email/ Login ID",
    password: "Password",
  }
  },
  error:{
    login:{
      userNotFound: "The login ID or password your provided is incorrect. Please try again.",
    },
    jwt:{
      identifierUsed: "Failed. Your third-party account has been linked to another EdCity account.",
      userIdUsed: "Failed. Your EdCity account has been linked to another third-party account.",
    }, 
  }
};
